<template>
  <basic-form
    ref="truckInfo"
    title="Truck Info"
    :mode="mode"
    :form-params="whatToShow"
  >
    <template v-slot:actions>
      <el-button
        size="mini"
        type="primary"
        :disabled="shipmentStatus === ShipmentDeleted"
        plain
        @click="editing = true"
        v-if="!editing && editable"
      >
        Edit
      </el-button>
      <el-button
        size="mini"
        type="primary"
        plain
        @click="saveTruckInfo"
        v-if="editing && editable"
      >
        Save
      </el-button>
      <el-button
        size="mini"
        type="danger"
        plain
        @click="editing = false"
        v-if="editing && editable"
      >
        Cancel
      </el-button>
    </template>
  </basic-form>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import { FormModes } from '@/core/configs/types'
// models
import {
  ShipmentDeleted,
  ShipmentPickUpInfoWrapUp,
  ShipmentPickUpInfoModifyForm
} from '@/core/models/shipment'
// components
import BasicForm from '@/components/common/BasicForm.vue'
// apis
import { modifyShipmentPickUpInfo } from '@/api/shipment'
// msg
import PagesMessage from '@/core/message/pages'
export default {
  name: 'PickUpInfo',
  props: {
    shipmentNo: {
      type: String,
      required: true
    },
    shipment: {
      type: Object,
      default: null
    },
    mode: {
      type: Object,
      default: () => FormModes.SPARSE
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BasicForm
  },
  data() {
    return {
      ShipmentDeleted,
      editing: false
    }
  },
  computed: {
    shipmentId() {
      return this.shipment.id
    },
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      return ShipmentPickUpInfoWrapUp(this.shipment ?? {})
    },
    editInfo() {
      const form = cloneDeep(ShipmentPickUpInfoModifyForm)
      Object.values(form).forEach(one => {
        one.value = (this.shipment.pickUpInfo ?? {})[one.key]
      })
      return form
    },
    shipmentStatus() {
      return this.shipment?.status ?? null
    }
  },
  methods: {
    saveTruckInfo() {
      const [passed, truckInfo] = this.$refs.truckInfo.validateAllInputs()
      if (passed) {
        this.$confirm('Update Pick Up Info?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          modifyShipmentPickUpInfo(this.shipmentId, truckInfo).then(res => {
            this.editing = false
            PagesMessage.emit(PagesMessage.eventMap.REFRESH_SHIPMENT_DETAIL)
          })
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
